// extracted by mini-css-extract-plugin
export default {"container":"GroupFooter_container__-1LN-"};